<template>
    <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0469 4.61963L12.0469 5.61963L8 9.6665L3.95313 5.61963L4.95312 4.61963L8 7.6665L11.0469 4.61963Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGArrowDown"
    }
</script>

<style scoped>

</style>
